import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const slides = [
  {
    image: '/images/test5.jpeg',
    title: 'Psychoterapia indywidualna',
    subtitle:
      'Skorzystaj z indywidualnych spotkań z psychoterapeutą, dostosowanych do Twoich potrzeb.',
  },
  {
    image: '/images/banner2.jpg',
    title: 'Psychoterapia indywidualna dla młodzieży',
    subtitle:
      'Pomagamy młodym ludziom w radzeniu sobie z trudnościami emocjonalnymi i społecznymi.',
  },
  {
    image: '/images/banner3.jpg',
    title: 'Pomoc psychologiczna',
    subtitle:
      'Wsparcie psychologiczne dla dzieci, młodzieży i dorosłych w trudnych momentach życia.',
  },
  {
    image: '/images/banner4.jpg',
    title: 'Terapia logopedyczna',
    subtitle:
      'Pomagamy dzieciom i dorosłym w poprawie mowy, komunikacji i artykulacji.',
  },
];


const HeroSlider = () => {
  return (
    <div className="w-full">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 6000 }}
        speed={1200}
        loop
        className="w-full"
      >
        {slides.map((slide, idx) => (
          <SwiperSlide key={idx}>
            <div
              className="w-full h-[600px] md:h-[700px] bg-cover bg-center relative flex items-center"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="absolute inset-0 bg-black/30 z-0" />

              <div className="max-w-screen-xl mx-auto px-6 z-10 text-white">
                <div className="max-w-xl">
                  <p className="text-xs tracking-[0.2em] text-[#FFDAB4] mb-3">
                    PSYCHOTERAPIA Marciniec
                  </p>
                  <h2 className="text-3xl md:text-5xl font-semibold mb-4 leading-snug">
                    {slide.title}
                  </h2>
                  <p className="text-base md:text-lg mb-6">{slide.subtitle}</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HeroSlider;
